<template>
  <loading-state
    v-if="!method"
    :loading="true"
  />
  <v-layout
    v-else
    row
    wrap
    color="transparent"
  >
    <v-flex
      v-if="method"
      xs12
      ma-3
    >
      <translations-tabs
        class="pb-4"
      >
        <template #default="{language}">
          <translatable
            :language="language"
            v-model="method"
            field-name="name"
          >
            <template
              #default="{ fieldValue, fieldMutator }"
            >
              <v-text-field
                v-model="fieldValue"
                :error-messages="method.displayErrors('name')"
                :label="$t('Name')"
                outline
                class="pb-0"
                @change="fieldMutator(fieldValue)"
              />
            </template>
          </translatable>
          <translatable
            :language="language"
            v-model="method"
            field-name="description"
          >
            <template
              #default="{ fieldValue, fieldMutator }"
            >
              <v-text-field
                v-model="fieldValue"
                :error-messages="method.displayErrors('description')"
                :label="$t('Description')"
                outline
                @change="fieldMutator(fieldValue)"
              />
            </template>
          </translatable>
        </template>
      </translations-tabs>
      <v-text-field
        v-model="method.apiKey"
        :error-messages="method.displayErrors('apiKey')"
        :label="$t('API Key')"
        outline
      />
      <v-text-field
        v-model="method.publishableKey"
        :error-messages="method.displayErrors('publishableKey')"
        :label="$t('Publishable Key')"
        outline
      />
      <v-layout align-start>
        <v-flex>
          <v-switch
            v-model="method.testMode"
            :label="$t('Test mode')"
          />
        </v-flex>
        <v-flex>
          <v-text-field
            v-model.number="method.order"
            :error-messages="method.displayErrors('order')"
            :label="$t('Order')"
            type="number"
            outline
          />
        </v-flex>
      </v-layout>
      <application-select v-model="method.application"/>
      <image-upload v-model="method.image"/>
    </v-flex>
  </v-layout>
</template>

<script>
import ApplicationSelect from '@/components/form/ApplicationSelect'
import LoadingState from '@/components/LoadingState'
import ImageUpload from '@/components/ImageUpload'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import Translatable from '@/components/widgets/Translatable'
export default {
  name: 'PaymentProviderStripe',
  components: { Translatable, TranslationsTabs, ImageUpload, LoadingState, ApplicationSelect },
  props: {
    method: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      schema: {
        'code': '',
        'name': '',
        'enabled': true,
        'application': null,
        'testMode': true,
        'apiKey': '******',
        'publishableKey': '',
        'description': '',
        'image': '',
        'order': null
      },
      sensitiveErrorFields: {
        apiKey: 'api key',
        publishableKey: 'publishable key'
      }
    }
  },

  created () {
    this.$emit('setPaymentData', {
      schema: this.schema,
      sensitiveErrorFields: this.sensitiveErrorFields
    })
  }
}
</script>
